import React from 'react'
import { AdminButton } from '../admin-actions.buttons'
import ActionButtonLink from '../ActionButtonLink/ActionButtonLink'

const AdminCardButtons: React.FC<{ buttons: AdminButton[] }> = ({ buttons }) => {

  return (
    <div className='columns is-multiline'>
      {buttons.map((item, idx) => (
        <div key={idx} className='column is-6'>
          <ActionButtonLink
            link={item.link}
            text={item.text}
            icon={item.icon}
          />
        </div>
      ))}
    </div>
  )
}

export default AdminCardButtons
